module.exports = __webpack_public_path__ + "img/4669834.svg";